import { getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';
import { useInView } from 'react-intersection-observer';

import { propTypesDataSocialProof } from './SocialProof.proptypes.js';

import Picture from '../../../../ui/Atoms/Picture';

import * as S from './SocialProof.styles.js';

export const SocialProofSlice = ({ slice }) => {
  const { ref } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  if (!slice) {
    return null;
  }

  const data = slice.primary || {};
  const {
    social_proof_slice_id: id,
    social_proof_title: title,
    social_proof_subtitle: subTitle,
  } = data || '';

  const logos = slice.items || {};

  if (!title) {
    return null;
  }

  const logoAmount = logos.length * 10 || 0;

  return (
    <S.SocialProof id={id} isVisible={true} ref={ref}>
      <S.WrapperTitle>
        <S.SocialProofTitle>{title}</S.SocialProofTitle>
        <S.SocialProofSubTitle>{subTitle}</S.SocialProofSubTitle>
      </S.WrapperTitle>
      <S.Slider>
        <S.List logoAmount={logoAmount}>
          {[...Array(10)].map((_, index) => (
            <React.Fragment key={`item-${index}`}>
              {logos.map((logo, idx) => {
                const image = getImage(logo.social_proof_logo);
                const logoAlt = logo.social_proof_logo?.alt || 'customer-logo';

                return (
                  <S.Item key={`${logo}-${idx}-${index}`}>
                    <Picture
                      altText={logoAlt || 'infinite-slide-picture'}
                      height='100%'
                      imageObject={image}
                    />
                  </S.Item>
                );
              })}
            </React.Fragment>
          ))}
        </S.List>
      </S.Slider>
    </S.SocialProof>
  );
};

SocialProofSlice.propTypes = {
  /**
   * Content of the HeaderBasic slice.
   */
  slice: PropTypes.shape(propTypesDataSocialProof),
};
